/* ============================================================================
   Custom Product Info Blocks — JS
   - Pack picker: 3 cards, dispatches pack:changed event on selection
   - Pack ATC: qty selector + submit button, listens to pack:changed globally
   - Tech showcase: swap between sets based on selected pack key
   ========================================================================== */
(function () {
  function bindPackPicker(root) {
    const cards = root.querySelectorAll('.pack-card');
    if (!cards.length) return;

    function activateCard(card) {
      cards.forEach((c) => {
        c.classList.toggle('is-selected', c === card);
        const radio = c.querySelector('.pack-card__radio');
        if (radio) radio.checked = c === card;
      });

      const packKey = card.dataset.packKey;
      const vid = card.dataset.variantId;
      document.dispatchEvent(new CustomEvent('pack:changed', {
        detail: {
          packKey: packKey,
          variantId: vid,
          price: card.dataset.price,
          comparePrice: card.dataset.comparePrice,
          saveAmt: card.dataset.saveAmt,
          productUrl: card.dataset.productUrl,
        },
      }));
    }

    cards.forEach((card) => {
      card.addEventListener('click', () => activateCard(card));
    });

    // Fire initial event so ATC + tech showcase sync on load
    const initial = root.querySelector('.pack-card.is-selected') || cards[0];
    if (initial) activateCard(initial);
  }

  function bindPackAtc() {
    // Any pack ATC blocks in the DOM listen for pack changes and update their hidden id.
    document.addEventListener('pack:changed', (e) => {
      if (!e.detail || !e.detail.variantId) return;
      document.querySelectorAll('[data-pack-hidden-id]').forEach((input) => {
        input.value = e.detail.variantId;
      });
    });
  }

  function bindPackPriceUpdate() {
    const saveRow = document.querySelector('.product__save-row');
    if (!saveRow) return;
    const priceEl = saveRow.querySelector('.price');
    if (!priceEl) return;

    const fmt = (window.theme && window.theme.settings && window.theme.settings.money_with_currency_format) || '{{amount}}';
    const money = (cents) => (typeof formatMoney === 'function' ? formatMoney(cents, fmt) : cents);

    const badge = priceEl.querySelector('.price__badge-sale');
    let badgeTemplate = null;
    if (badge) {
      const raw = badge.innerHTML.trim();
      const swapped = raw.replace(/[₹$€£¥]\s?[\d,.\s]+/, '{amount}');
      badgeTemplate = swapped !== raw ? swapped : null;
    }

    document.addEventListener('pack:changed', (e) => {
      if (!e.detail) return;
      const price = parseInt(e.detail.price, 10) || 0;
      const compare = parseInt(e.detail.comparePrice, 10) || 0;
      const onSale = compare > price;

      priceEl.classList.toggle('price--on-sale', onSale);

      const regularOnly = priceEl.querySelector('.price__regular .price-item--regular');
      if (regularOnly) regularOnly.textContent = money(price);

      const saleCurrent = priceEl.querySelector('.price__sale .price-item--sale.price-item--last');
      if (saleCurrent) saleCurrent.textContent = money(price);

      const saleCompare = priceEl.querySelector('.price__sale s.price-item--regular');
      if (saleCompare) saleCompare.textContent = money(compare || price);

      if (badge) {
        if (onSale && badgeTemplate) {
          badge.innerHTML = badgeTemplate.replace('{amount}', money(compare - price));
          badge.hidden = false;
        } else {
          badge.hidden = true;
        }
      }
    });
  }

  function bindQty(root) {
    const buttons = root.querySelectorAll('[data-qty-step]');
    const input = root.querySelector('.pack-qty__input');
    if (!buttons.length || !input) return;
    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const step = parseInt(btn.dataset.qtyStep, 10) || 1;
        const val = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = val;
      });
    });
  }

  function bindTechShowcase(root) {
    const sets = root.querySelectorAll('.tech-showcase__set');
    if (!sets.length) return;

    function activate(packKey) {
      let found = false;
      sets.forEach((set) => {
        const match = set.dataset.packKey === packKey;
        if (match) {
          set.setAttribute('data-active', 'true');
          found = true;
        } else {
          set.removeAttribute('data-active');
        }
      });
      if (!found && sets[0]) sets[0].setAttribute('data-active', 'true');
    }

    document.addEventListener('pack:changed', (e) => {
      if (e.detail && e.detail.packKey) activate(e.detail.packKey);
    });
  }

  function bindDayNightBanner() {
    const dayEls = document.querySelectorAll('.day-banner');
    const nightEls = document.querySelectorAll('.night-banner');
    if (!dayEls.length && !nightEls.length) return;

    function applyBySide(side) {
      const isNight = side === 'night';
      dayEls.forEach((el) => { el.hidden = isNight; });
      nightEls.forEach((el) => { el.hidden = !isNight; });
    }

    function packKeyToSide(packKey) {
      return (packKey === 'pm' || packKey === 'night') ? 'night' : 'day';
    }

    applyBySide('day');

    document.addEventListener('pack:changed', (e) => {
      if (e.detail && e.detail.packKey) applyBySide(packKeyToSide(e.detail.packKey));
    });

    document.addEventListener('side:changed', (e) => {
      if (e.detail && e.detail.side) applyBySide(e.detail.side);
    });
  }

  function init() {
    bindPackAtc();
    bindPackPriceUpdate();
    document.querySelectorAll('[data-pack-picker]').forEach(bindPackPicker);
    document.querySelectorAll('[data-pack-atc-wrapper]').forEach(bindQty);
    document.querySelectorAll('[data-tech-showcase]').forEach(bindTechShowcase);
    bindDayNightBanner();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
